import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap"; // Bootstrap components
import Breadcrumbs from "../../components/Common/Breadcrumb"; // Import Breadcrumb component
import axios from "axios";

const fetchCardData = async (userId) => {
  try {
    const response = await axios.get(`https://api.bluhawk.live/logs/${userId}`);
    return response.data; // Return the scan results
  } catch (error) {
    console.error("Error fetching scan results:", error);
    throw error;
  }
};

const Logs = () => {
  document.title = "tm-results";
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const userId = obj.username;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCardData(userId);
        setCardData(data);
      } catch (error) {
        console.error("Error fetching data in useEffect:", error);
      } finally {
        setLoading(false); // Stop loading after fetching data
      }
    };
    fetchData();
  }, [userId]); // Dependencies

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (cardData.length === 0) {
    return (
      <div className="page-content">
        <Breadcrumbs breadcrumbItem="Logs" /> {/* Add breadcrumb */}
        {/* Empty State */}
        <Card>
        <div className="text-center p-5">
          <div className="mb-4">
            <i className="mdi mdi-file-search text-primary" style={{ fontSize: "4rem" }} />
          </div>
          <h3 className="mb-3 font-weight-bold">No Logs Available</h3>
          <p className="text-muted mb-4">
            It seems there are no logs available at the moment. This might be due to a delay in data updates or no recent activity.
            <br />
            Please check back later or try refreshing the page to get the latest data.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <button className="btn btn-primary px-4 py-2" onClick={() => window.location.reload()}>
              Refresh Data
            </button>
          </div>
        </div>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      {/* Breadcrumb section */}
      <div className="page-content">
        <Breadcrumbs breadcrumbItem="Logs" /> {/* Add breadcrumb */}
        
        <Row className="g-4"> {/* Add class "g-4" for spacing between the cards */}
          {cardData.map((card, index) => (
            <Col sm="4" key={index}>
              <Card className="mini-stats-wid mb-4" style={{ height: "100%" }}>
                <CardBody className="d-flex flex-column">
                  <div className="d-flex justify-content-between">
                    <div className="text-left">
                      <h5>{card.title}</h5>
                      <p className="text-muted">Total: {card.total}</p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-auto">
                    {Object.entries(card.stats).map(([key, value]) => (
                      <div className="text-center" key={key}>
                        <p className="mb-2">{key}</p>
                        <h4>{value}</h4>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Logs;
